import React from 'react';
import { Link } from 'react-router';
import $ from 'jquery';
import Item from './Bookmarks/Item';


class Bookmarks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: props.items,
            selected: false
        };
        this.prev_scroll = 0;
    }

    removeBookmark(event) {
        event.preventDefault();
        let removeItemsIds = [];
        if(this.state.items && this.state.items.length > 0) {
            let items = this.state.items;
            let result_items = [];
            items.map(function(item) {
                if(!item.selected) {
                    result_items.push(item);
                } else {
                    removeItemsIds.push(item.id);
                }
            });
            this.props.remove(removeItemsIds);
            this.setState({items: result_items});
        }
    }

    componentWillReceiveProps(p) {
        this.setState({items: p.items});
    }

    checkboxHandler(event) {
        let selected = this.state.selected;
        let items = this.state.items;
        items.map((item, index) => items[index].selected = !selected);
        this.setState({
            items: items,
            selected: !selected
        });
    }


    itemSelectedStatus(id) {
        let items = this.state.items;
        let find = false;
        items.map(function(item, index) {
            if(item.id == id) {
                items[index].selected = !item.selected;
                find = true;
            }
        });
        //update if needed
        if(find) this.setState({items: items});
    }

    componentDidUpdate() {
        $('.m2content__header').removeClass('fixed_header');
    }

    __scrollHandler(event) {
        if(event.target.scrollTop < this.prev_scroll) {
            $('.m2content__header').addClass('fixed_header');
        } else {
            $('.m2content__header').removeClass('fixed_header');
        }
        this.prev_scroll = event.target.scrollTop;
    }

    render() {
        let removeIconSvg = '<use xlink:href="#icon-remove-bookmark"></use>';
        return (
        <div className="m2bookmark_container">
            <div className="m2bookmark_options">
                <div className="m2checkbox2">
                    <input type="checkbox" onChange={this.checkboxHandler.bind(this)}/>
                </div>
                <Link className="m2remove_bookmark" to="#" onClick={this.removeBookmark.bind(this)}>
                    <svg dangerouslySetInnerHTML={{__html: removeIconSvg}}></svg>
                </Link>

            </div>
            <div className="m2feeds__list" onScroll={this.__scrollHandler.bind(this)}>
                {this.state.items && this.state.items.length > 0 && this.state.items.map(item => <Item more={this.props.more} onSelectItem={this.itemSelectedStatus.bind(this)} key={"bookmark_" + item.id} {...item} />)}
                {this.state.items && this.state.items.length == 0 && <div className="bookmark_list_empty">Нет элементов</div>}
            </div>
        </div>);
    }
}


export default Bookmarks;


// WEBPACK FOOTER //
// ./src/components/Bookmarks.js